import { eventEmitter } from '@magicdoor/solid-use-case-core';
import { createSignal, ErrorBoundary, onCleanup, onMount, Show } from 'solid-js';
export const ErrorHandler = (props) => {
    const [error, setError] = createSignal(undefined);
    const [shouldDisplay, setShouldDisplay] = createSignal(true);
    const reportError = (error) => {
        const shouldReport = props.onWillReportError?.(error);
        if (shouldReport) {
            setShouldDisplay(true);
            setError(error);
            props.onDidReportError?.(error);
        }
    };
    const clearError = () => {
        setError(undefined);
    };
    onMount(() => {
        eventEmitter.registerForErrors(reportError);
    });
    onCleanup(() => {
        eventEmitter.unregisterFromErrors(reportError);
    });
    return (<ErrorBoundary fallback={(error, reset) => props.renderErrorDialog({ error, onClose: reset })}>
      {props.children}
      <Show when={error() && shouldDisplay()}>{props.renderErrorDialog({ error: error(), onClose: clearError })}</Show>
    </ErrorBoundary>);
};
